export const formatIntoPercentage = (value: number | bigint, maximumFractionDigits = 2) => {
  const option: Intl.NumberFormatOptions = {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: maximumFractionDigits,
  };
  return new Intl.NumberFormat('en', option).format(value);
};
